import { render } from "./RequestFeedbackModal.vue?vue&type=template&id=72acdddc&scoped=true"
import script from "./RequestFeedbackModal.vue?vue&type=script&lang=js"
export * from "./RequestFeedbackModal.vue?vue&type=script&lang=js"

import "./RequestFeedbackModal.vue?vue&type=style&index=0&id=72acdddc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72acdddc"]])

export default __exports__